import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    CombineInputGroup,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

const AddBankDetails = ({ addBankAccountMutate, addBankAccountLoading, handleClose }) => {
    const initialValues = {
        holderName: "",
        accountNum: "",
        confirmAccountNum: "",
        ifsc: "",
        bankAddress: "",
        bankName: "",
    };

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSubmit = (values) => {

        if (!values.holderName.trim()) {
            return toast.error("Beneficiary name is required");
        }
        if (!/^[A-Za-z0-9. ]+$/.test(values.holderName)) {
            return toast.error("Beneficiary name can only contain letters, numbers, spaces & dots");
        }
        if (values.holderName.length < 4) {
            return toast.error("Beneficiary name must be at least 4 characters long");
        }

        if (!values.accountNum) {
            return toast.error("Account number is required");
        }
        if (!/^[0-9]+$/.test(values.accountNum)) {
            return toast.error("Account number must contain only numbers");
        }
        if (values.accountNum.length < 9 || values.accountNum.length > 18) {
            return toast.error("Account number must be between 9 and 18 digits");
        }

        if (!values.confirmAccountNum) {
            return toast.error("Please confirm account number");
        }
        if (values.accountNum !== values.confirmAccountNum) {
            return toast.error("Account numbers do not match");
        }

        if (!values.ifsc) {
            return toast.error("IFSC code is required");
        }
        if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(values.ifsc)) {
            return toast.error("Enter a valid IFSC code");
        }

        const payload = {
            holderName: values.holderName,
            accountNum: values.accountNum,
            ifsc: values.ifsc,
            bankAddress: values.bankAddress,
            type: 1,
            upiId: "",
            bankName: values.bankName,
            properties: [],
        };

        addBankAccountMutate(payload);
    };

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <Header>
                <h1 className="text-white text-lg font-medium">Add Bank Details</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <div className=" custom-scrollbar px-6 h-full flex flex-col justify-between">
                <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="holderName">Beneficiary Name *</Label>
                                        <FieldWrappers>
                                            <Field type="text" name="holderName" id="holderName" autoComplete="off" />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <CombineInputGroup>
                                        <InputGroup>
                                            <Label htmlFor="accountNum">A/C Number *</Label>
                                            <FieldWrappers>
                                                <Field type="text" name="accountNum" id="accountNum" autoComplete="off" />
                                            </FieldWrappers>
                                        </InputGroup>

                                        <InputGroup>
                                            <Label htmlFor="confirmAccountNum">Confirm A/C Number *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    name="confirmAccountNum"
                                                    id="confirmAccountNum"
                                                    autoComplete="off"
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    </CombineInputGroup>

                                    <InputGroup>
                                        <Label htmlFor="ifsc">IFSC *</Label>
                                        <FieldWrappers>
                                            <Field type="text" name="ifsc" id="ifsc" autoComplete="off" />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="bankName">Bank Name</Label>
                                        <FieldWrappers>
                                            <Field type="text" name="bankName" id="bankName" autoComplete="off" />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="bankAddress">Bank Address</Label>
                                        <FieldWrappers>
                                            <Field type="text" name="bankAddress" id="bankAddress" autoComplete="off" />
                                        </FieldWrappers>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>

                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={addBankAccountLoading}>
                                    {addBankAccountLoading ? "Submiting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;

export default AddBankDetails;
